import { put, select, takeLatest } from 'redux-saga/effects'
import { FillablePDFsConstants } from '../store/fillablePDFs.constants'
import { getFillablePDFsSelector } from '../selectors'
import { getCrewListSelector } from '../../crew/selectors'
import { setAuthor } from '../store/fillablePDFs.actions'
import { IFillablePDFsState } from '../store/fillablePDFs.types'
import { ICrewMemberList } from '../../crew/store/crew.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* initializeFillablePDF() {
  try {
    const fillablePDFsState: IFillablePDFsState = yield select(getFillablePDFsSelector)
    const crewList: ICrewMemberList = yield select(getCrewListSelector)

    if (!fillablePDFsState.author && crewList.length > 0) {
      yield put(setAuthor(crewList[0].userId))
    }
  } catch (e) {
    yield put(throwPcrException(`initializeFillablePDF() error: ${e}`))
  }
}

export function* initializeFillablePDFsaga() {
  yield takeLatest([FillablePDFsConstants.INITIALIZE_FILLABLE_PDF], initializeFillablePDF)
}
